import { useAuthStore } from '@/stores/auth'

let menusRefreshing: Promise<void> | null = null
let menusRefreshedAt = 0
const MENUS_TTL = 60_000

async function ensureSession() {
  const auth = useAuthStore()
  if (!auth.token) {
    auth.restoreSession()
  }
  if (!auth.token) return false
  // 菜单刷新做 60s 节流：/auth/me 线上耗时 ~2s，此前每次导航都阻塞等待，
  // 既拖慢切页又拉长导航 pending 窗口（与 <transition> 竞态相关）。
  // 仅冷启动（本地无菜单缓存）或缓存过期时才阻塞等待；其余情况后台刷新、立即放行。
  const stale = Date.now() - menusRefreshedAt > MENUS_TTL
  if (!menusRefreshing) {
    menusRefreshing = auth.refreshMenus().then(() => {
      menusRefreshedAt = Date.now()
    }).finally(() => {
      menusRefreshing = null
    })
  }
  if (stale || auth.menus.length === 0) {
    await menusRefreshing
  }
  return true
}

export const authGuard = async (to: any) => {
  const code = to.meta?.code
  if (!code || code === 'public') return true
  const auth = useAuthStore()
  const ok = await ensureSession()
  if (!ok) return { path: '/admin/login', query: { redirect: to.fullPath } }
  if (auth.hasMenu(code)) return true
  // 如果没有权限且目标已经是 /admin/dashboard，允许进入（防止死循环）
  if (to.path === '/admin/dashboard') return true
  return { path: '/admin/dashboard' }
}

export const mfaGuard = async (to: any) => {
  const code = to.meta?.code
  if (!code || code === 'public') return true
  const auth = useAuthStore()
  const ok = await ensureSession()
  if (!ok) return { path: '/admin/login' }
  return auth.mfaOK ? true : { path: '/admin/login' }
}
